import axios from 'axios';
import { DefaultFishGroupGraph } from 'views/planning-prognosis/features/view-fish-group/types/default-fish-group-graph.type';

// GET
// /ewosapi/v1/planandprognosis/graph/fishgroup/{fishGroupId}/default
export const getDefaultFishGroupGraph = async (
  fishGroupId: string,
  periodType: number = 1
): Promise<DefaultFishGroupGraph> => {
  const res = await axios.get<DefaultFishGroupGraph>(
    `/ewosapi/v1/planandprognosis/graph/fishgroup/${fishGroupId}/default?periodType=${periodType}`
  );
  return res.data;
};
